import angular from 'angular';
import { localeEvents } from '@/angular/modules/vrm.locales';
import VerifyMFAModal from '@/vue/components/modals/VerifyMFAModal';

angular.module('vrm.core').controller('ProfileSettingsController', ProfileSettingsController);

/**
 * @constructor
 * @ngInject
 */
function ProfileSettingsController(
    $log,
    $scope,
    $state,
    UserService,
    locale,
    $rootScope,
    VrmModalService,
    vrmNotificationsService,
    vrmNotificationType,
    localStorageService,
    ApiService,
) {
    $log.info('ProfileSettingsController');

    $scope.screensaverTimeouts = [];
    $scope.temperatureOptions = [];
    $scope.selected = { screensaverTimeout: null, useFahrenheit: null, useGallons: null };
    $scope.newUser = {
        email_confirm: null,
        current_password: null,
    };

    function setScreenSaver() {
        if ($scope.user && $scope.selected.screensaverTimeout === null) {
            const currentTimeout = $scope.user.screensaverTimeout ? parseInt($scope.user.screensaverTimeout) : 0;
            $scope.selected.screensaverTimeout = _.find($scope.screensaverTimeouts, val => val.id === currentTimeout);
        }
    }

    function setScreenSaverTimeouts() {
        $scope.screensaverTimeouts = [
            { id: 0, name: locale.getString('profilesettings.screensaver_disabled') },
            { id: 60000, name: locale.getString('profilesettings.screensaver_one_minute') },
            { id: 180000, name: locale.getString('profilesettings.screensaver_x_minutes', { minutes: 3 }) },
            { id: 300000, name: locale.getString('profilesettings.screensaver_x_minutes', { minutes: 5 }) },
            { id: 600000, name: locale.getString('profilesettings.screensaver_x_minutes', { minutes: 10 }) },
            { id: 900000, name: locale.getString('profilesettings.screensaver_x_minutes', { minutes: 15 }) },
            { id: 1800000, name: locale.getString('profilesettings.screensaver_x_minutes', { minutes: 30 }) }
        ];
    }

    $scope.$watch('user', (user) => {
        if (user) {
            $scope.newUser = { ...$scope.newUser, ...user };
        }
    });

    locale.ready('profilesettings').then(() => {
        setScreenSaverTimeouts();

        $scope.temperatureOptions = [
            { id: false, name: locale.getString('profilesettings.celsius') },
            { id: true, name: locale.getString('profilesettings.fahrenheit') },
        ];

        // Populate select
        $scope.$watch('user', (user) => {
            setScreenSaver();
            if (user) {
                $scope.selected.useFahrenheit = _.find($scope.temperatureOptions, (val) => {
                    return val.id === user.useFahrenheit;
                });
            }
        });
    });

    $scope.$on(localeEvents.localeChanges, () => {
        locale.ready('profilesettings').then(() => {
            setScreenSaverTimeouts();
            $scope.selected.screensaverTimeout = null;
            setScreenSaver();
        });
    });

    $scope.saveProfileForm = () => {
        if (!$scope.profileForm.$valid) return;

        const changes = _.clone($scope.newUser);
        if ($scope.user.email === changes.email) {
            // Remove unnecessary fields if email is not changed
            delete changes.email;
            delete changes.email_confirm;
            delete changes.current_password;
        } else {
            if ($scope.user.twostepEnabled) {
                VrmModalService.openVueModal(VerifyMFAModal, {
                    successCallback: (token) => {
                        changes.sms_token = token;
                        updateUser(changes);
                    }
                });
                return;
            }
        }

        updateUser(changes);
    }

    function updateUser(changes) {
        UserService.save(changes).then(success => {
            if (success) {
                $state.go('base.installation-overview');
            }
        });
    }

    $scope.deleteAccount = function () {
        const handleConfirmation = password => {
            if (!password) return;

            UserService.deleteUserAccount(password).then(function (deleted) {
                if (deleted) {
                    // Clear the context and user data without calling the /logout endpoint (which does not work for the just deleted user)
                    localStorageService.remove("token");
                    $scope.$emit('logout');
                    $state.go('login');
                }
            });
        };


        VrmModalService.openPasswordConfirmModal($scope, handleConfirmation);
    };

    $scope.unmuteAlarmNotifications = () => {
        UserService.getUser().then(user => {
            ApiService.call2(`/users/${user.id}/unmute-alarm-notifications`)
                .then(() => {
                    $scope.user.alarmNotificationsMuted = false;
                    vrmNotificationsService.add({
                        type: vrmNotificationType.SUCCESS,
                        message: locale.getString('profilesettings.unmute_alarm_notifications_success')
                    });
                }, () => {
                    vrmNotificationsService.add({
                        type: vrmNotificationType.ERROR,
                        message: locale.getString('profilesettings.unmute_alarm_notifications_error')
                    });
                });
        });
    };
}
